
import { computed } from "vue";
import { Options } from "vue-class-component";
import ListQuestions from "./listQuestions/ListQuestions.vue";
import Base from "@/components/base/Base.vue";
@Options({
  components: {
    ListQuestions
  }
})
export default class SettingsChallenge extends Base {
  public settingsChallenge = computed(
    () => this.store.getters.getChallengeSettingSelected
  );
}
